export default "__VITE_ASSET__ePeXhxLg__"